module.exports = __webpack_public_path__ + "img/wheel.aee79e4c.png";